var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAirextraction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.255,
    height: 22.9,
    viewBox: "0 0 30.255 22.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    transform: "translate(-261.55 -275.658)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M294.065,329.816s4.4-2.573,5.889-3.468c1.562-.939.458-3.926-1.374-2.879s-6.276,3.884-6.276,3.884",
    transform: "translate(-21.095 -32.079)",
    fill: "none",
    stroke: "#005e98",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M278.69,319.4s4.4-2.573,5.889-3.468c1.562-.939.458-3.926-1.374-2.879s-6.216,3.861-6.216,3.861",
    transform: "translate(-10.3 -24.735)",
    fill: "none",
    stroke: "#005e98",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_60",
    "data-name": "Line 60",
    x2: 1.707,
    y2: 1.135,
    transform: "translate(274.279 291.194)",
    fill: "none",
    stroke: "#005e98",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M318.224,306.3l1.9,1.332,10.273-5.562-.065-3.141-6.936-4.122",
    transform: "translate(-39.365 -12.032)",
    fill: "none",
    stroke: "#005e98",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M291.861,301.755l.131-2.486,7.067-3.8",
    transform: "translate(-20.783 -12.501)",
    fill: "none",
    stroke: "#005e98",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M316.925,280.7v9.072c0,1.5,1.265,1.8,3.031,1.8s2.523-.73,2.523-1.581V280.7",
    transform: "translate(-38.449 -4.441)",
    fill: "none",
    stroke: "#005e98",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_61",
    "data-name": "Line 61",
    x1: 8.637,
    y1: 5.3,
    transform: "translate(262.376 282.253)",
    fill: "none",
    stroke: "#005e98",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_62",
    "data-name": "Line 62",
    x1: 7.786,
    y1: 4.58,
    transform: "translate(265.647 280.813)",
    fill: "none",
    stroke: "#005e98",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_63",
    "data-name": "Line 63",
    x1: 8.637,
    y1: 5.3,
    transform: "translate(267.348 278.85)",
    fill: "none",
    stroke: "#005e98",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_64",
    "data-name": "Line 64",
    x1: 7.394,
    y1: 4.319,
    transform: "translate(271.078 277.738)",
    fill: "none",
    stroke: "#005e98",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 1.472,
    cy: 1.145,
    rx: 1.472,
    ry: 1.145,
    transform: "translate(281.57 293.129) rotate(-60)",
    fill: "none",
    stroke: "#005e98",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 1.472,
    cy: 1.145,
    rx: 1.472,
    ry: 1.145,
    transform: "translate(284.58 291.493) rotate(-60)",
    fill: "none",
    stroke: "#005e98",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 1.472,
    cy: 1.145,
    rx: 1.472,
    ry: 1.145,
    transform: "translate(287.53 289.923) rotate(-60)",
    fill: "none",
    stroke: "#005e98",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAirextraction);
export default __webpack_public_path__ + "static/media/Icon-Air extraction.97a72770318d4a30bddbf03e8f48edfa.svg";
export { ForwardRef as ReactComponent };